var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconClearinput18 = function SvgAIconClearinput18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "none",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z",
    fill: "#F2F2F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11.4999L11.4999 6.5",
    stroke: "#8C8C96",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11.4999L6.5001 6.5",
    stroke: "#8C8C96",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
};
export { SvgAIconClearinput18 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4IiBmaWxsPSJub25lIiBzdHJva2U9Im5vbmUiPgo8cGF0aCBkPSJNMCA5QzAgNC4wMjk0NCA0LjAyOTQ0IDAgOSAwQzEzLjk3MDYgMCAxOCA0LjAyOTQ0IDE4IDlDMTggMTMuOTcwNiAxMy45NzA2IDE4IDkgMThDNC4wMjk0NCAxOCAwIDEzLjk3MDYgMCA5WiIgZmlsbD0iI0YyRjJGNyIgLz4KPHBhdGggZD0iTTYuNSAxMS40OTk5TDExLjQ5OTkgNi41IiBzdHJva2U9IiM4QzhDOTYiIHN0cm9rZS13aWR0aD0iMS4zIiBzdHJva2UtbGluZWNhcD0icm91bmQiIC8+CjxwYXRoIGQ9Ik0xMS41IDExLjQ5OTlMNi41MDAxIDYuNSIgc3Ryb2tlPSIjOEM4Qzk2IiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiAvPgo8L3N2Zz4=";